<template>
  <div :style="getElementStyle">
    <div v-if="!isDefalutPosq" style="display: flex">
      <div>
        <label for="text" style="margin-right: 5px">{{ data.label }}</label>
        <span
          v-if="data.validations.required"
          style="color: red; font-weight: bold; margin-left: 5px"
        >
          *
        </span>
        <i
          class="el-icon-copy-document"
          v-if="!isDataTableField"
          @click="copyDocument"
        ></i>
        <span v-if="data.description" style="margin-right: 5px">
          <i class="el-icon-info" :title="data.description"></i>
        </span>
      </div>
      <el-col>
        {{ form[data.key] }}
        <span v-if="isActive" class="setting-icon" @click="openSettings">
          <i class="el-icon-s-tools" />
        </span>
      </el-col>
    </div>

    <el-row align="middle" v-else>
      <el-col
        :span="showLabel && !isDefalutPosq ? 4 : data.description ? 20 : 24"
        :style="computedStyles"
      >
        <label for="text" style="margin-right: 5px">{{ data.label }}</label>
        <span
          v-if="data.validations.required"
          style="color: red; font-weight: bold"
        >
          *
        </span>
        <i
          class="el-icon-copy-document"
          v-if="!isDataTableField"
          @click="copyDocument"
        ></i>
        <span>
          <el-popover
            v-if="data.description"
            placement="top-start"
            trigger="hover"
            :content="data.description"
          >
            <i class="el-icon-info" slot="reference"></i>
          </el-popover>
        </span>
        <span v-if="isActive" class="setting-icon" @click="openSettings">
          <i class="el-icon-s-tools" />
        </span>
      </el-col>
      <el-col :span="showLabel && !isDefalutPosq ? 12 : 24">
        <div v-if="!isView" style="height: 150px;">
          <div class="outer">
            <div class="inner">
              <div class="slots"></div>
            </div>
          </div>
        </div>

        <!-- When in view mode -->
        <div v-else style="margin-top: 10px">
          {{ form[data.key] || "No slot selected." }}
        </div>
        <!-- <div v-if="!isView">
          <div  class="slots">
            <div class="slot">
            </div>
          </div>
        </div> -->
        <!-- <div v-else>
          {{ form[selectedValue] }}
        </div> -->
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: [
    "data",
    "value",
    "form",
    "isView",
    "isActive",
    "isDataTableField",
    "isInDataTable",
    "labelAlignments",
  ],
  computed: {
    selectedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    computedStyles() {
      const styles = {};
      styles.display = "flex";
      if (this.labelAlignments || this.data?.styles?.labelAlignments) {
        styles.justifyContent =
          this.labelAlignments || this.data?.styles?.labelAlignments;
      }
      return styles;
    },
    getStyle() {
      return `height:${this.data.height - 30}px; width: 100%;`;
    },
    getElementStyle() {
      let borderStyle = "";
      if (this.data.styles) {
        const {
          border_type,
          border_size,
          border_color,
          background,
          label_color,
          font,
        } = this.data.styles;
        let type = border_type || "solid";
        let size = border_size ? border_size + "px" : "0px";
        let color = border_color || "";
        let font_size = font?.font_size || 14;
        let bold = font?.style === 1 || font?.style === 3 ? "bold" : "";
        let italic = font?.style === 2 || font?.style === 3 ? "italic" : "";

        borderStyle += `border:${type} ${size} ${color};`;
        if (background) borderStyle += `background:${background};`;
        borderStyle += `font-size:${font_size}px;`;
        if (bold) borderStyle += `font-weight:${bold};`;
        if (italic) borderStyle += `font-style:${italic};`;
        if (label_color) borderStyle += `color:${label_color};`;
      }
      return borderStyle;
    },
    isDefalutPosq() {
      return !(this.data.styles && this.data.styles.labelStyle === "right");
    },
  },
  data() {
    return {
      showLabel: true,
    };
  },
  mounted() {
    if (this.data.styles?.labelStyle === "hide") {
      this.showLabel = false;
    }
  },
  methods: {
    copyDocument() {
      this.$emit("copy-document", this.data.key);
    },
    openSettings() {
      this.$emit("settings");
    },
  },
};
</script>
<style scoped>
.slots {
  display: flex;
  flex-wrap: wrap;
  /* // margin-top: 10px; */
  height: 100px;
  max-height: 250px;
  overflow-y: auto;
  padding-bottom: 30px;
  text-align: center;
}
.slot {
  padding: 3px 0px 3px 0px;
  margin: 5px;
  /* width: 9%; */
  /* // height: 150px; */
  border: 1px solid #3f3a3a;
  cursor: pointer;
  border-radius: 4px;
}
.slot.available {
  background-color: #4d58ef;
  color: white;
  height: 20%;
}
.slot.selected {
  background-color: #eee; 
  /* //#3e912a */
  /* font-weight: bold; */
  color: black;
}
.slot.disabled {
  background-color: #eee;
  cursor: not-allowed;
  color: #080808;
  height: 20%;
}
.outer {
  border: 1px solid #ccc;
  border-radius: 12px;
  overflow: hidden;
  max-height: 180px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.inner {
  height: 100%;
  overflow-y: auto;
  margin: 2% 2% 5% 2%;
}

/* Optional: Customize scrollbar for WebKit browsers */
.inner::-webkit-scrollbar {
  width: 8px;
}

.inner::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 8px;
}

.inner::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 8px;
}

.inner::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
